import { useState } from 'react';
import { Minus, Plus } from 'lucide-react';
import SectionHeading from './SectionHeading.jsx';
import { faqItems } from '../data/siteData.js';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="section section--light faq-section" id="gyik">
      <div className="container faq-layout">
        <div className="faq-sidebar">
          <SectionHeading
            eyebrow="Gyakori kérdések"
            title="Mielőtt belevágunk."
            text="Nem találtad meg a választ? Írj nyugodtan, és röviden átbeszéljük a helyzetedet."
          />
          <a className="text-link" href="#kapcsolat">
            Kérdezek Martintól
          </a>
        </div>

        <div className="faq-list">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            const answerId = `faq-answer-${index}`;

            return (
              <article className={`faq-item ${isOpen ? 'faq-item--open' : ''}`} key={item.question}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  <span>{item.question}</span>
                  {isOpen ? <Minus size={20} /> : <Plus size={20} />}
                </button>
                <div className="faq-answer" id={answerId} hidden={!isOpen}>
                  <p>{item.answer}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
